/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coral_Rosy_Stork_GripInputs */

const en_coral_rosy_stork_grip = /** @type {(inputs: Coral_Rosy_Stork_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

const de_coral_rosy_stork_grip = /** @type {(inputs: Coral_Rosy_Stork_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisen`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Coral_Rosy_Stork_GripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coral_rosy_stork_grip = /** @type {((inputs?: Coral_Rosy_Stork_GripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coral_Rosy_Stork_GripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coral_rosy_stork_grip(inputs)
	return de_coral_rosy_stork_grip(inputs)
});